import React from 'react';
import PropTypes from 'prop-types';
import './css/OverviewCards.css';

const OverviewCard = ({ icon, title, value, subtitle, color = '#3a7bd5' }) => {
  const formatValue = (val) => {
    // If it's a string with a % sign, format as percentage
    if (typeof val === 'string' && val.includes('%')) {
      const numValue = parseFloat(val.replace('%', ''));
      if (!isNaN(numValue)) {
        return `${numValue.toFixed(2)}%`;
      }
    }
    // If it's a number, format as whole number
    if (typeof val === 'number') {
      return val.toLocaleString();
    }
    // Otherwise return as is
    return val;
  };

  return (
    <div className="overview-card">
      <div className="card-icon" style={{ background: `linear-gradient(135deg, ${color}, ${color}dd)` }}>
        {icon}
      </div>
      <div className="card-content">
        <h3>{title}</h3>
        <p className="card-value">{formatValue(value)}</p>
        <p className="card-subtitle">{subtitle}</p>
      </div>
    </div>
  );
};

OverviewCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string.isRequired,
  color: PropTypes.string,
};

const OverviewCards = ({ cards }) => {
  return (
    <section className="analytics-overview">
      {cards.map((card, index) => (
        <OverviewCard
          key={index}
          icon={card.icon}
          title={card.title}
          value={card.value}
          subtitle={card.subtitle}
          color={card.color}
        />
      ))}
    </section>
  );
};

OverviewCards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      title: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      subtitle: PropTypes.string.isRequired,
      color: PropTypes.string,
    })
  ).isRequired,
};

export { OverviewCard, OverviewCards };
export default OverviewCards;
